import { Routes } from '@angular/router';
import { authGuard } from '@core/auth';
import AdminLayout from '@layout/layout';

export const routes: Routes = [
  // OIDC callback
  {
    path: 'callback',
    loadComponent: () => import('@core/auth/callback'),
  },
  // Admin
  {
    path: '',
    component: AdminLayout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },

      // Dashboard
      {
        path: 'dashboard',
        loadChildren: () => import('@features/dashboard/routes'),
      },

      // Assistant
      {
        path: 'assistant',
        loadChildren: () => import('@features/assistant/routes'),
      },

      // Finance-invoice-tasks
      {
        path: 'finance-invoice-tasks',
        loadChildren: () => import('@features/finance-invoice-tasks/routes'),
      },

      // Finance-invoices (search)
      {
        path: 'finance-invoices',
        loadChildren: () => import('@features/finance-invoices/routes'),
      },

      // Property-management invoices (tasks)
      {
        path: 'property-management-invoices',
        loadChildren: () =>
          import('@features/property-management-invoices/routes'),
      },

      // Property-management invoice search
      {
        path: 'property-management-invoice-search',
        loadChildren: () =>
          import('@features/property-management-invoice-search/routes'),
      },

      // Incidents (tasks)
      {
        path: 'incidents',
        loadChildren: () => import('@features/incidents/routes'),
      },

      // Incident search
      {
        path: 'incident-search',
        loadChildren: () => import('@features/incident-search/routes'),
      },

      // Works history (search)
      {
        path: 'works-history',
        loadChildren: () => import('@features/works-history/routes'),
      },

      // CGI history (search)
      {
        path: 'cgi-history',
        loadChildren: () => import('@features/cgi-history/routes'),
      },

      // Application offers (appels à candidatures)
      {
        path: 'application-offers',
        loadChildren: () => import('@features/application-offers/routes'),
      },

      // Notifications
      {
        path: 'notifications',
        loadChildren: () => import('@features/notifications/routes'),
      },

      // Settings
      {
        path: 'settings',
        loadChildren: () => import('@features/settings/routes'),
      },

      // 404 - Catch all
      /*{
        path: '**',
        redirectTo: 'dashboard',
      },*/
    ],
  },
];
